import styled from 'styled-components'

import {
  OptionCheckbox as LMFOptionCheckbox,
  OptionSwatch as LMFOptionSwatch,
  fromLg,
  fromMd,
} from '@syconium/little-miss-figgy'

export const List = styled.div<{
  columnDisplayLength: number
  mobileColumnDisplayLength?: number
}>`
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(${o => o.mobileColumnDisplayLength || 8}, auto);
  width: 100%;
  margin-top: ${o => o.theme.spacing(0.5)};

  ${fromMd} {
    display: grid;
    grid-auto-flow: column;
    grid-template-rows: repeat(
      ${o =>
        o.columnDisplayLength < 40
          ? `${Math.ceil(o.columnDisplayLength / Math.ceil(o.columnDisplayLength / 10))}`
          : `${Math.ceil(o.columnDisplayLength / 4)}`},
      auto
    );
    width: 100%;
  }
  ${fromLg} {
    grid-template-rows: repeat(
      ${o =>
        o.columnDisplayLength < 60
          ? `${Math.ceil(o.columnDisplayLength / Math.ceil(o.columnDisplayLength / 10))}`
          : `${Math.ceil(o.columnDisplayLength / 6)}`},
      auto
    );
  }
`

export const Label = styled.span`
  font-weight: 600;
`

export const OptionCheckbox = styled(LMFOptionCheckbox)`
  ${fromMd} {
    min-width: 150px;
    overflow: auto;
    padding: 5px 10px;
  }
`

export const OptionSwatch = styled(LMFOptionSwatch)`
  display: inline-flex;
  font-weight: 600;
  width: 100%;
  ${fromMd} {
    width: 150px;
    overflow: auto;
    padding: 10px 15px;
  }
`
